/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { GetAllPositionsOptions, GetAllPositionsResponses } from '../types/GetAllPositions'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Get all users' positions
 * {@link /v1/ledger/positions}
 */
export function getAllPositions<ThrowOnError extends boolean = true>(
  options: Options<GetAllPositionsOptions, ThrowOnError> = {},
): Unwrappable<RequestResult<GetAllPositionsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/ledger/positions',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetAllPositionsResponses, ThrowOnError>>,
  )
}
